module.exports = __webpack_public_path__ + "img/1.11e0bc0b.png";